<template>
  <div class="flex flex-col h-full">
    <PaymentStackForm
      action="create"
      :fn="create"
      @cancel="$emit('cancel')"
    />
  </div>
</template>

<script lang="ts" setup>
import { useRoute } from 'vue-router';
import PaymentStackForm from '../../components/payment_settings_form/index.vue';
import { CreateStack, createStack } from '../../api/create_stack';

const route = useRoute();
const projectId = route.params.projectId as string;

const emit = defineEmits([
  'submit',
  'cancel',
]);

const create = async (values: CreateStack) => {
  await createStack({ projectId, form: values });
  emit('submit');
};

</script>
